import React from 'react';
import { isInApp, getQueryObj } from '../../utils/common';
import OpenTip from '../open-tip';
const queryParams = getQueryObj();
const FilterApp = props => {
  const isApp = isInApp();
  // 开发调试用
  const isTest = !!queryParams['devtest'];
  return isTest || isApp ? props.children : <OpenTip />;
};

export default FilterApp;
